<template>

	<Head>
		<title>Graven op Internet - Levensverhalen in De Oude Kerk</title>

	</Head>
	<section class="z-20 pl-4 pt-4 pr-4 md:p-6 text-white lg:h-20 lg:fixed lg:w-full"
		:class="isExpo ? ' bg-green-900':' bg-blue-mellow'"
	>
		<header class="-mb-2 md:mb-0 flex-col md:flex-row md:flex md:justify-between md:items-center">
			<div class="flex items-center">
				<h1 class="font-bold text-lg uppercase tracking-wide whitespace-nowrap"><Link href="/" class="cursor-pointer relative z-20">Graven op Internet</Link></h1>
				<p v-if="username" class="text-sm ml-4 italic">ingelogd als {{ username }}</p>
			</div>
			<div class="relative -top-6 md:top-0 w-full md:w-auto flex items-center">
				<Nav />
			</div>
		</header>
	</section>
	<section>
		<div class="h-full min-h-full lg:pt-20 grid grid-cols-1 lg:grid-rows-1 lg:grid-cols-5 lg:gap-1 bg-fixed bg-cover bg-no-repeat" 
			:style="{ 'background-image': kerkplaat }">
			<div 
				id="zerkenvloerdiv" 
				class="row-span-1 order-last lg:order-first"
				:class="isBreed ? 'lg:col-span-2':'lg:col-span-3'"
				style="transition: 2s;"
				>
				<Zerkenvloer v-if="isDesktop" />
			</div>
			<div 
				class="text-sm text-white oldstyle-nums pb-8 pt-3 pr-4 pl-4 lg:pr-8 lg:pl-8"
				style="min-height: calc(100vh - 80px);"
				:class="[ isBreed ? 'lg:col-span-3':'lg:col-span-2', isExpo ? ' bg-green-800':' bg-blue-dark' ]"
			>
				<BreadCrumbs :crumbs="crumbsData"></BreadCrumbs>
				<slot />
			</div>
		</div>
	</section>
</template>
<script setup>
import { Head } from "@inertiajs/inertia-vue3";
</script>
<script>
import Nav from "./Nav";
import Zerkenvloer from "./Zerkenvloer";
import BreadCrumbs from "./BreadCrumbs";
import { Link } from "@inertiajs/inertia-vue3";

export default {
	components: { Nav, Link , Zerkenvloer, BreadCrumbs },

	computed: {
		username() {
			return this.$page.props.auth.user.username;
		},
		crumbsData() {
			return this.$page.props.breadcrumbs;
		},
		isBreed() {
			// console.log('wat is breed? ' + this.$page.props.isBreed);		
			// window.dispatchEvent(new Event('resize'));
			return this.$page.props.isBreed;
		},
		isExpo() {
			// console.log('is dit een expo? ' + this.$page.props.isExpo);		
			return this.$page.props.isExpo;
		},
		isDesktop() {
			// console.log('is dit een expo? ' + this.$page.props.isDesktop);		
			return this.$page.props.isDesktop;
		},
		kerkplaat() {
			if ( 'area' in this.$page.props ) {
				return `url('/img/${this.$page.props.area.id.toLowerCase()}.jpg')`;
			} else {
				return "url('/img/z.jpg')";
			}
			// kerkplaat
		}
	},
	watch: {
		// kijk naar isBreed
		isBreed(nieuw,oud) {
			this.$nextTick(function () {
				// console.log('nieuw: ' + nieuw);
				// window.dispatchEvent(new Event('resize'));
			});

			setTimeout(() => {
			    window.dispatchEvent(new Event('resize'));
			}, 0);
		}
	},
	// mounted() {
	// 	this.$nextTick(function () {
	// 		window.dispatchEvent(new Event('resize'));
	// 	});
	// }
};

</script>
